import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { connect, getQuizSessions, getQuizSessionById } from '@instructure/quiz-core';
import { AttemptHistory as AttemptHistoryPresenter } from './presenter';
function getAttemptData(state, attempt) {
  var authoritativeResult, quizSession;
  var resultObject = {};
  if (attempt.quizSessionId) {
    quizSession = getQuizSessionById(state, attempt.quizSessionId);
    authoritativeResult = quizSession.findAuthoritativeResult();
    resultObject = authoritativeResult.toObject();
  }
  return _objectSpread(_objectSpread({}, attempt), {}, {
    score: resultObject.score,
    pointsPossible: resultObject.pointsPossible
  });
}
export function mapStateToProps(state, ownProps) {
  var attemptHistory = ownProps.attemptHistory;
  if (!attemptHistory || attemptHistory.length === 0) return {};
  var attemptHistoryWithData = attemptHistory.map(function (attempt) {
    return getAttemptData(state, attempt);
  });
  if (ownProps.findAuthoritativeAttempt) {
    var authoritativeAttempt = ownProps.findAuthoritativeAttempt(attemptHistoryWithData);
    attemptHistoryWithData = attemptHistoryWithData.map(function (attempt) {
      return _objectSpread(_objectSpread({}, attempt), {}, {
        authoritative: attempt === authoritativeAttempt
      });
    });
  }
  return {
    attemptHistory: attemptHistoryWithData
  };
}
export var mapDispatchToProps = {
  getQuizSessions: getQuizSessions
};
export var AttemptHistory = connect(mapStateToProps, mapDispatchToProps)(AttemptHistoryPresenter);
export default AttemptHistory;